module.exports = __webpack_public_path__ + "media/images/sp/stores/umeda/umeda_sns_01-cde4e50df660f4ddca89ddea3200961f.jpg";